import React, { Component } from 'react';
import '../static/css/bootstrap.min.css'
import '../index.css'
import login from '../resources/p1_img2.svg'
import join from '../resources/p1_img3.svg'
import Scroll from 'react-scroll-to-element';


class Section1 extends Component {

  render() {
    return (
      <section id="page_1">
        <div className="container">
          <div className="row">

            <div className="placeholder"></div>
            <div className="col-xs-offset-6" id="content">
              <div className="title">
                <div className="subtitle mainText">
                  Musio<br/>
                  Academy Plan
                </div>

                <div className="subText">
                  教えるをもっとワクワク、<br/>
                  もっと簡単に
                </div>
              </div>
              <div className="button_wrapper">
                <div className="col-sm-6 col-xs-12 button">
                  <a href="https://academy-admin.themusio.com">
                    <img src={login} />
                  </a>
                </div>

                <div className="col-sm-6 col-xs-12 button">
                  <a href="#">
                    <Scroll type='id' element='page_8'>
                      <img src={join} />
                    </ Scroll>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Section1;



// WEBPACK FOOTER //
// ./src/sections/Section1.js